import { getQuantityType } from "../../components/dms_common/DmsUtils";
import { getDataFromLocalDb } from "../../services/dbService";
import { fetchAllDataFromApiNew, getPieceFilterMapping } from "../createSecondaryOrder/CreateSecondaryOrderService";
import { addToUomWiseAllocation, addToUomWiseAllocationPrimaryReturn } from "../secondaryOrder/ManageStockAllocationUtils";
import { fetchBatchDataForSkuList } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { getBatchDetailsFromDbPrimary } from "../SalesReturn/SalesReturnService";
import { OrderType, PrimaryBatchDetailsMap } from "../../types/types";
import { SkuDataForUnsellableReturn, withoutGRNBatchDetails } from "./PrimaryReturnWithoutGRNEdit";
import { getStockData } from "../../services/claimService";
import { argv0 } from "process";
import { parseInt } from "lodash";
import { getPricingData } from "../../services/catalogueService";
import { ProductMetadata } from "../createSecondaryOrder/models";
import { SummaryData } from "./PrimaryReturnWithoutGRN";
import { getConfigData } from "../../services/configurationService";
import { batch } from "react-redux";
import { fetchBatchWisePricingOfLoginId } from "../../services/manageOrderService";

export interface QuantityReason {
  caseQty: number;
  pieceQty: number;
  otherQty: number;
  reason: string;
  quantityError?: boolean;
  reasonError?: boolean;
}

export interface QuantityObj {
  caseQty: number;
  pieceQty: number;
  otherQty: number;
  unsellableCaseQty?: number;
  unsellablePieceQty?: number;
  unsellableOtherQty?: number;
  reason?: string;
}

export interface BatchDetails {
  batchId: string;
  skuCode: string;
  batchCode: string;
  otherUnitName: string;

  totalCaseQuantity: number;
  totalPieceQuantity: number;
  totalOtherQuantity: number;

  acceptedCaseQuantity: number;
  acceptedPieceQuantity: number;
  acceptedOtherQuantity: number;
  rejectedCaseQuantity: number;
  rejectedPieceQuantity: number;
  rejectedOtherQuantity: number;

  //Returned quantity from previous returns
  totalReturnedCaseQuantity?: number;
  totalReturnedPieceQuantity?: number;
  totalReturnedOtherQuantity?: number;

  acceptedReturnedCaseQuantity?: number;
  acceptedReturnedPieceQuantity?: number;
  acceptedReturnedOtherQuantity?: number;
    
  rejectedReturnedCaseQuantity?: number;
  rejectedReturnedPieceQuantity?: number;
  rejectedReturnedOtherQuantity?: number;
  
  //Stock Details
  totalAvailableCases?: number;
  totalAvailablePieces?: number;
  totalAvailableOtherUnits?: number;

  totalUnsellableCases?: number;
  totalUnsellablePieces?: number;
  totalUnsellableOtherUnits?: number;

  //Calculated as min(availableQty, acceptedQty - acceptedReturnedQty)
  acceptedReturnableCaseQuantity?: number;
  acceptedReturnablePieceQuantity?: number;
  acceptedReturnableOtherQuantity?: number;

  //Calculated as min(unsellableQty, rejectedQty - rejectedReturnedQty)
  rejectedReturnableCaseQuantity?: number;
  rejectedReturnablePieceQuantity?: number;
  rejectedReturnableOtherQuantity?: number;

  //these will be populated on the basis of qtyReasonMap. Whenever the map changes these quantities should change
  newAcceptedReturnedCaseQuantity?: number;
  newAcceptedReturnedPieceQuantity?: number;
  newAcceptedReturnedOtherQuantity?: number;
  
  newRejectedReturnedCaseQuantity?: number;
  newRejectedReturnedPieceQuantity?: number;
  newRejectedReturnedOtherQuantity?: number;

  acceptedReturnValue?: number;
  rejectedReturnValue?: number;
  returnValue?: number;

  
  priceToRetailer: number;
  mrp: number;

  grnRejectionReason?: string;

  //string can only be accepted/rejected
  //the value will by caseQuantity, pieceQuantity, otherUnitQuantity, reason
  qtyReasonMap?: Record<string, QuantityReason[]>;

}



export interface SkuData {
  id: string;  
  skuCode: string;
  batchCode: string;
  skuName: string;
  packType: string;
  brand?: string;

  priceToRetailer?: number;
  mrp?: number;

  totalReturnableCases?: number;
  totalReturnablePieces?: number;
  totalReturnableOtherUnits?: number;

  totalReturnedCases?: number;
  totalReturnedPieces?: number;
  totalReturnedOtherUnits?: number;

  totalInvoicedCases?: number;
  totalInvoicedPieces?: number;
  totalInvoicedOtherUnits?: number;

  newReturnedCases?: number;
  newReturnedPieces?: number;
  newReturnedOtherUnits?: number;

  totalReturnedValue?: number;

  caseToPieceQuantity?: number;
  otherToPieceQuantity?: number;

  showMultipleRows?: boolean;
  otherUnitName?: string;

  batches: BatchDetails[];
  mergedRows: BatchDetails[];
}


export const generateBatchIdStockMap = async (skuMap: Record<string, SkuData>, grnNumberOfInvoice: string) => {

  const BATCH_SIZE = 100;
  const allBatchCodesArray = Object.keys(skuMap);

  let stocksData: any[] = [];

  for (let i = 0; i < allBatchCodesArray.length; i += BATCH_SIZE) {
    const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE).join(",");
    const chunkStockData = await fetchBatchDataForSkuList(
      chunk,
      getQuantityType()
    );
    stocksData = stocksData.concat(chunkStockData);
  }

  const stockData = await getStockData();

  const unsellableStockData: Record<string, any> = {};

  stockData.forEach((stockItem: any) => {
    const { batchId, qty, quantityType, grnNumber } = stockItem;

    if (!grnNumber) return;
    if (grnNumber !== grnNumberOfInvoice) return;

    if (!unsellableStockData[batchId]) {
      unsellableStockData[batchId] = {
        availableCaseQty: 0,
        availablePieceQty: 0,
        availableOtherQty: 0,
      };
    }

    if (quantityType === "caseQty") {
      unsellableStockData[batchId].availableCaseQty += qty;
    } else if (quantityType === "pieceQty") {
      unsellableStockData[batchId].availablePieceQty += qty;
    } else if (quantityType === "otherQty") {
      unsellableStockData[batchId].availableOtherQty += qty;
    }
  });

  const updatedStockData: Record<
    string,
    {
      availableCaseQty: number;
      availablePieceQty: number;
      availableOtherQty: number;
      unsellableCaseQty: number;
      unsellablePieceQty: number;
      unsellableOtherQty: number;
    }
  > = {};

  stocksData?.forEach((obj: any) => {
    const { batchId, caseQty, pieceQty, otherQty } = obj;

    if (!updatedStockData[batchId]) {
      // initialize if not exists
      updatedStockData[batchId] = {
        availableCaseQty: 0,
        availablePieceQty: 0,
        availableOtherQty: 0,
        unsellableCaseQty: 0,
        unsellablePieceQty: 0,
        unsellableOtherQty: 0,
      };
    }

    updatedStockData[batchId].availableCaseQty += caseQty?.availableQty ?? 0;
    updatedStockData[batchId].availablePieceQty += pieceQty?.availableQty ?? 0;
    updatedStockData[batchId].availableOtherQty += otherQty?.availableQty ?? 0;
    // updatedStockData[batchId].unsellableCaseQty += caseQty?.unsellableQty ?? 0;
    // updatedStockData[batchId].unsellablePieceQty += pieceQty?.unsellableQty ?? 0;
    // updatedStockData[batchId].unsellableOtherQty += otherQty?.unsellableQty ?? 0;
      
  });

  // Unsellable stock from GRN-specific stock
  Object.keys(unsellableStockData).forEach((batchId) => {
    if (!updatedStockData[batchId]) {
      updatedStockData[batchId] = {
        availableCaseQty: 0,
        availablePieceQty: 0,
        availableOtherQty: 0,
        unsellableCaseQty: 0,
        unsellablePieceQty: 0,
        unsellableOtherQty: 0,
      };
    }
    updatedStockData[batchId].unsellableCaseQty = unsellableStockData[batchId].availableCaseQty;
    updatedStockData[batchId].unsellablePieceQty = unsellableStockData[batchId].availablePieceQty;
    updatedStockData[batchId].unsellableOtherQty = unsellableStockData[batchId].availableOtherQty;
  });

  return updatedStockData;
};

export const generateReturnRows = async (invoiceData: any, grnNumber: string): Promise<SkuData[]> => {
  if (!Array.isArray(invoiceData) || invoiceData.length === 0) return [];
  
  const {otherUnitLabelPrimaryReturn} =  JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  // Fully rejected
  const allowedReturnsConfig = await getConfigData("dms_configuration", "allowedReturnQtyTypes");
  const allowedReturns = allowedReturnsConfig[0]?.configValue ?? [
    "REJECTED",
  ];
  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  const raisedReturns = invoiceData.filter((i: any) => i.type.toLowerCase() === "primaryreturn");
  const remaining = invoiceData.filter((i: any) => i.type.toLowerCase() !== "primaryreturn");

  const mainInvoice = invoiceData.filter((i: any) => (i.type.toLowerCase() === "primary" || i.type.toLowerCase() === "invoice"))[0];

  if (!mainInvoice || !Array.isArray(mainInvoice.salesDetails)) return [];

  const skuMap: Record<string, SkuData> = {};

  mainInvoice.salesDetails.forEach((batchNode: any) => {
    const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";

    const isFree = batchNode.type === "freeItem";
    if (isFree) return;

    const batchDetails: BatchDetails = {
      batchId: batchNode.batchId ?? "unassigned",
      skuCode: skuCode,
      batchCode: skuCode,
      otherUnitName: products[skuCode]?.otherUnitName ?? otherUnitLabelPrimaryReturn,
      totalCaseQuantity: batchNode.initialCaseQuantity ?? 0,
      totalPieceQuantity: batchNode.initialPieceQuantity ?? 0,
      totalOtherQuantity: batchNode.initialOtherUnitQuantity ?? 0,
      acceptedCaseQuantity: 0,
      acceptedPieceQuantity: 0,
      acceptedOtherQuantity: 0,
      rejectedCaseQuantity: 0,
      rejectedPieceQuantity: 0,
      rejectedOtherQuantity: 0,
      totalReturnedCaseQuantity: 0,
      totalReturnedPieceQuantity: 0,
      totalReturnedOtherQuantity: 0,
      acceptedReturnedCaseQuantity: 0,
      acceptedReturnedPieceQuantity: 0,
      acceptedReturnedOtherQuantity: 0,
      rejectedReturnedCaseQuantity: 0,
      rejectedReturnedPieceQuantity: 0,
      rejectedReturnedOtherQuantity: 0,
      priceToRetailer: batchNode.price ?? 0,
      mrp: batchNode.mrp ?? 0,
    };

    if (!skuMap[skuCode]) {
      skuMap[skuCode] = { id: skuCode, skuCode, batchCode: skuCode, skuName: "", batches: [], packType: "", mergedRows: []};
    }
    skuMap[skuCode].batches.push(batchDetails);
    skuMap[skuCode].packType = getPieceFilterMapping(products[skuCode]?.pieceSize);
    skuMap[skuCode].brand = products[skuCode]?.brand ?? "";
    skuMap[skuCode].skuName = products[skuCode]?.skuDescription ?? "";
    skuMap[skuCode].caseToPieceQuantity = batchNode?.productInfo?.caseToPieceQuantity ?? 0;
    skuMap[skuCode].otherToPieceQuantity = batchNode?.productInfo?.otherUnitToPieceQuantity ?? 0;
    skuMap[skuCode].priceToRetailer = batchNode.price ?? 0;
    skuMap[skuCode].mrp = batchNode.mrp ?? 0;
    skuMap[skuCode].showMultipleRows = true
    skuMap[skuCode].otherUnitName = products[skuCode]?.otherUnitName ?? otherUnitLabelPrimaryReturn 
  });

  if (remaining.length === 1) {
    // Fully accepted or fully rejected GRN
    const isAccepted = mainInvoice.grnStatus === "ACCEPTED"; // fixed: was mainInvoice[0].type
    if (isAccepted && allowedReturns.includes("ACCEPTED")) {
      // Fully accepted
      Object.values(skuMap).forEach((skuData) => {
        skuData.batches.forEach((batch) => {
          batch.acceptedCaseQuantity = batch.totalCaseQuantity;
          batch.acceptedPieceQuantity = batch.totalPieceQuantity;
          batch.acceptedOtherQuantity = batch.totalOtherQuantity;
        });
      });
    } else if (!isAccepted && allowedReturns.includes("REJECTED")){
      Object.values(skuMap).forEach((skuData) => {
        skuData.batches.forEach((batch) => {
          batch.rejectedCaseQuantity = batch.totalCaseQuantity;
          batch.rejectedPieceQuantity = batch.totalPieceQuantity;
          batch.rejectedOtherQuantity = batch.totalOtherQuantity;
          batch.grnRejectionReason = mainInvoice?.grnRejectionReason ?? " ";
        });
      });
    }
  } else {
    // Partially accepted/rejected
    const rejectedGrn = invoiceData.filter((i: any) => i.type.toLowerCase() === "return")[0];
    if (rejectedGrn && Array.isArray(rejectedGrn.salesDetails)) {
      rejectedGrn.salesDetails.forEach((batchNode: any) => {
        const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";
        const skuData = skuMap[skuCode];
        if (skuData) {
          const batch = skuData.batches.find((b) => b.batchId === batchNode.batchId);
          if (batch) {
            batch.rejectedCaseQuantity = Math.abs(batchNode.initialCaseQuantity ?? 0);
            batch.rejectedPieceQuantity = Math.abs(batchNode.initialPieceQuantity ?? 0);
            batch.rejectedOtherQuantity = Math.abs(batchNode.initialOtherUnitQuantity ?? 0);

            batch.acceptedCaseQuantity = Math.max(batch.totalCaseQuantity - batch.rejectedCaseQuantity, 0);
            batch.acceptedPieceQuantity = Math.max(batch.totalPieceQuantity - batch.rejectedPieceQuantity, 0);
            batch.acceptedOtherQuantity = Math.max(batch.totalOtherQuantity - batch.rejectedOtherQuantity, 0);

            if (!allowedReturns.includes("ACCEPTED")){
              batch.acceptedCaseQuantity = 0;
              batch.acceptedPieceQuantity = 0;
              batch.acceptedOtherQuantity = 0;
            } 

            if (!allowedReturns.includes("REJECTED")) {
              batch.rejectedCaseQuantity = 0;
              batch.rejectedPieceQuantity = 0;
              batch.rejectedOtherQuantity = 0;
            }
            batch.grnRejectionReason = batchNode?.remarks ?? ""
          }
        }
      });
    }
  }

  raisedReturns.forEach((returnNode: any) => {
    if (!Array.isArray(returnNode.salesDetails)) return;

    returnNode.salesDetails.forEach((batchNode: any) => {
      const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";
      const skuData = skuMap[skuCode];
      if (!skuData) return;

      const batch = skuData.batches.find((b) => b.batchId === batchNode.batchId);
      if (batch) {
        // Initialize if undefined
        batch.totalReturnedCaseQuantity = (batch.totalReturnedCaseQuantity ?? 0) + Math.abs(batchNode.initialCaseQuantity ?? 0);
        batch.totalReturnedPieceQuantity = (batch.totalReturnedPieceQuantity ?? 0) + Math.abs(batchNode.initialPieceQuantity ?? 0);
        batch.totalReturnedOtherQuantity = (batch.totalReturnedOtherQuantity ?? 0) + Math.abs(batchNode.initialOtherUnitQuantity ?? 0);

        // Initial values (only set once — keep first recorded total)

        batchNode.batchIds.map((returnedBatch: any) => {
          if (returnedBatch.batchId === batch.batchId) {

            if (returnedBatch.accepted && allowedReturns.includes("ACCEPTED")) {
              batch.acceptedReturnedCaseQuantity = (batch.acceptedReturnedCaseQuantity ?? 0) + (returnedBatch.caseQty ?? 0);
              batch.acceptedReturnedPieceQuantity = (batch.acceptedReturnedPieceQuantity ?? 0) + (returnedBatch.pieceQty ?? 0);
              batch.acceptedReturnedOtherQuantity = (batch.acceptedReturnedOtherQuantity ?? 0) + (returnedBatch.otherQty ?? 0);
            } else if (!returnedBatch.accepted && allowedReturns.includes("REJECTED")) {
              batch.rejectedReturnedCaseQuantity = (batch.rejectedReturnedCaseQuantity ?? 0) + (returnedBatch.caseQty ?? 0);
              batch.rejectedReturnedPieceQuantity = (batch.rejectedReturnedPieceQuantity ?? 0) + (returnedBatch.pieceQty ?? 0);
              batch.rejectedReturnedOtherQuantity = (batch.rejectedReturnedOtherQuantity ?? 0) + (returnedBatch.otherQty ?? 0);
            }
          }
        });
      }
    });
  });

  const batchIdStockMap = await generateBatchIdStockMap(skuMap, grnNumber);

  populateStockInSkuMap(skuMap, batchIdStockMap);

  performSkuCalculations(skuMap, products);

  const batchDetails = await getBatchDetailsFromDbPrimary("primaryReturn");
  if (batchDetails) populateSkuReasons(skuMap, batchDetails ?? {});

  calculateReturnValues(skuMap);
  calculateNewReturnQuantities(skuMap);

  Object.values(skuMap).forEach((skuData) => {
    skuData.mergedRows = skuData.batches;
  });

  console.log("Generated SKU Map:", skuMap);

  return Object.values(skuMap)
};

const populateSkuReasons = (skuMap: Record<string, SkuData>, batchDetails:PrimaryBatchDetailsMap) => {
  Object.values(skuMap).forEach((skuData) => {
    const batchDetailsForSku = batchDetails[skuData.batchCode]
    populateQtyReasonMap(skuData, batchDetailsForSku);
  })
}

const populateQtyReasonMap = (skuData: SkuData, batchDetailsOfSku: Record<string, Record <string, QuantityReason[]>>) => {
  skuData.batches.forEach((batch) => {
    batch.qtyReasonMap = batchDetailsOfSku[batch.batchId]
  })
}


export const populateStockInSkuMap = (skuMap: Record<string, SkuData>, stockData: Record<string, any>) => {
  Object.values(skuMap).forEach((skuData) => {
    skuData.batches.forEach((batch) => {
      const batchStock = stockData[batch.batchId];
      if (batchStock) {
        batch.totalAvailableCases = batchStock.availableCaseQty;
        batch.totalAvailablePieces = batchStock.availablePieceQty;
        batch.totalAvailableOtherUnits = batchStock.availableOtherQty;
        
        batch.totalUnsellableCases = batchStock.unsellableCaseQty;
        batch.totalUnsellablePieces = batchStock.unsellablePieceQty;
        batch.totalUnsellableOtherUnits = batchStock.unsellableOtherQty;
      }
    });
  });
}

const getNormalizedQuantity = (caseQty: number, pieceQty: number, otherQty: number, caseToPieceQty: number, otherToPieceQty: number) => {
  return caseQty * caseToPieceQty + pieceQty + otherQty * otherToPieceQty;
}

export const performSkuCalculations = (
  skuMap: Record<string, SkuData>,
  products: any
) => {
  // iterate values of the object
  Object.values(skuMap).forEach((skuData) => {
    calculateSkuTotals(skuData, products[skuData.skuCode]);
  });
};

export const calculateSkuTotals = (skuData: SkuData, products: any) => {
  
  let totalReturnedCases = 0;
  let totalReturnedPieces = 0;
  let totalReturnedOtherUnits = 0;
  
  let totalInvoicedCases = 0;
  let totalInvoicedPieces = 0;
  let totalInvoicedOtherUnits = 0;
 
  let totalAcceptedCases = 0;
  let totalAcceptedPieces = 0;
  let totalAcceptedOtherUnits = 0;

  let totalRejectedCases = 0;
  let totalRejectedPieces = 0;
  let totalRejectedOtherUnits = 0;

  let totalAvailableCases = 0;
  let totalAvailablePieces = 0;
  let totalAvailableOtherUnits = 0;
  
  let totalUnsellableCases = 0;
  let totalUnsellablePieces = 0;
  let totalUnsellableOtherUnits = 0;

  let totalAcceptedReturnedCases = 0;
  let totalAcceptedReturnedPieces = 0;
  let totalAcceptedReturnedOtherUnits = 0;

  let totalRejectedReturnedCases = 0;
  let totalRejectedReturnedPieces = 0;
  let totalRejectedReturnedOtherUnits = 0;

  skuData.batches.forEach((batch) => {
    totalReturnedCases += (batch.acceptedReturnedCaseQuantity ?? 0) + (batch.rejectedReturnedCaseQuantity ?? 0);
    totalReturnedPieces += (batch.acceptedReturnedPieceQuantity ?? 0) + (batch.rejectedReturnedPieceQuantity ?? 0);
    totalReturnedOtherUnits += (batch.acceptedReturnedOtherQuantity ?? 0) + (batch.rejectedReturnedOtherQuantity ?? 0);

    totalAcceptedReturnedCases += batch.acceptedReturnedCaseQuantity ?? 0;
    totalAcceptedReturnedPieces += batch.acceptedReturnedPieceQuantity ?? 0;
    totalAcceptedReturnedOtherUnits += batch.acceptedReturnedOtherQuantity ?? 0;
    
    totalRejectedReturnedCases += batch.rejectedReturnedCaseQuantity ?? 0;
    totalRejectedReturnedPieces += batch.rejectedReturnedPieceQuantity ?? 0;
    totalRejectedReturnedOtherUnits += batch.rejectedReturnedOtherQuantity ?? 0;

    totalInvoicedCases += batch.totalCaseQuantity ;
    totalInvoicedPieces += batch.totalPieceQuantity ;
    totalInvoicedOtherUnits += batch.totalOtherQuantity ;

    totalAcceptedCases = (totalAcceptedCases ?? 0) + (batch.acceptedCaseQuantity ?? 0);
    totalAcceptedPieces = (totalAcceptedPieces ?? 0) + (batch.acceptedPieceQuantity ?? 0);
    totalAcceptedOtherUnits = (totalAcceptedOtherUnits ?? 0) + (batch.acceptedOtherQuantity ?? 0);
    
    totalRejectedCases = (totalRejectedCases ?? 0) + (batch.rejectedCaseQuantity ?? 0);
    totalRejectedPieces = (totalRejectedPieces ?? 0) + (batch.rejectedPieceQuantity ?? 0);
    totalRejectedOtherUnits = (totalRejectedOtherUnits ?? 0) + (batch.rejectedOtherQuantity ?? 0);

    totalAvailableCases += batch.totalAvailableCases ?? 0;
    totalAvailablePieces += batch.totalAvailablePieces ?? 0;
    totalAvailableOtherUnits += batch.totalAvailableOtherUnits ?? 0;
    
    totalUnsellableCases += batch.totalUnsellableCases ?? 0;
    totalUnsellablePieces += batch.totalUnsellablePieces ?? 0;
    totalUnsellableOtherUnits += batch.totalUnsellableOtherUnits ?? 0;

    const normAcceptedStk = getNormalizedQuantity(
      batch.totalAvailableCases ?? 0,
      batch.totalAvailablePieces ?? 0,
      batch.totalAvailableOtherUnits ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    );

    const qtyReasonedAcceptedQty = getNormalizedQuantity(
      batch.acceptedCaseQuantity ?? 0,
      batch.acceptedPieceQuantity ?? 0,
      batch.acceptedOtherQuantity ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    ) - getNormalizedQuantity(
      batch.acceptedReturnedCaseQuantity ?? 0,
      batch.acceptedReturnedPieceQuantity ?? 0,
      batch.acceptedReturnedOtherQuantity ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    );

    const batchAcceptedQty = Math.min(
      normAcceptedStk,
      Math.max(0, qtyReasonedAcceptedQty)
    )

    const totalAcceptedReturnableBatchQty = addToUomWiseAllocationPrimaryReturn(
      products,
      batchAcceptedQty,
      ""
    );

    batch.acceptedReturnableCaseQuantity = totalAcceptedReturnableBatchQty.cs;
    batch.acceptedReturnablePieceQuantity = totalAcceptedReturnableBatchQty.pi;
    batch.acceptedReturnableOtherQuantity = totalAcceptedReturnableBatchQty.oth;

    const normUnsellableStk = getNormalizedQuantity(
      batch.totalUnsellableCases ?? 0,
      batch.totalUnsellablePieces ?? 0,
      batch.totalUnsellableOtherUnits ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    );

    const qtyReasonedRejectedQty = getNormalizedQuantity(
      batch.rejectedCaseQuantity ?? 0,
      batch.rejectedPieceQuantity ?? 0,
      batch.rejectedOtherQuantity ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    ) - getNormalizedQuantity(
      batch.rejectedReturnedCaseQuantity ?? 0,
      batch.rejectedReturnedPieceQuantity ?? 0,
      batch.rejectedReturnedOtherQuantity ?? 0,
      skuData.caseToPieceQuantity ?? 0,
      skuData.otherToPieceQuantity ?? 0
    );

    const batchRejectedQty = Math.min(
      normUnsellableStk,
      Math.max(0, qtyReasonedRejectedQty)
    )

    const totalRejectedReturnableBatchQty = addToUomWiseAllocationPrimaryReturn(
      products,
      batchRejectedQty,
      ""
    );
    
    batch.rejectedReturnableCaseQuantity = totalRejectedReturnableBatchQty.cs;
    batch.rejectedReturnablePieceQuantity = totalRejectedReturnableBatchQty.pi;
    batch.rejectedReturnableOtherQuantity = totalRejectedReturnableBatchQty.oth;

  });

  const normalizedAcceptedQty = getNormalizedQuantity(
    totalAcceptedCases,
    totalAcceptedPieces,
    totalAcceptedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );

  const normalizedAcceptedReturnedQty = getNormalizedQuantity(
    totalAcceptedReturnedCases,
    totalAcceptedReturnedPieces,
    totalAcceptedReturnedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );
  
  const normalizedRejectedQty = getNormalizedQuantity(
    totalRejectedCases,
    totalRejectedPieces,
    totalRejectedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );

  const normalizedRejectedReturnedQty = getNormalizedQuantity(
    totalRejectedReturnedCases,
    totalRejectedReturnedPieces,
    totalRejectedReturnedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );

  const normalizedAvailableQty = getNormalizedQuantity(
    totalAvailableCases,
    totalAvailablePieces,
    totalAvailableOtherUnits,

    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );
   
  const normalizedUnsellableQty = getNormalizedQuantity(
    totalUnsellableCases,
    totalUnsellablePieces,
    totalUnsellableOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );
  
  const acceptedReturnableQty = Math.min(Math.max(0, normalizedAcceptedQty - normalizedAcceptedReturnedQty), normalizedAvailableQty);
  const rejectedReturnableQty = Math.min(Math.max(0, normalizedRejectedQty - normalizedRejectedReturnedQty), normalizedUnsellableQty);

  const totalReturnableQty = addToUomWiseAllocationPrimaryReturn(
    products,
    acceptedReturnableQty + rejectedReturnableQty,
    ""
  )

  skuData.totalInvoicedCases = totalInvoicedCases;
  skuData.totalInvoicedPieces = totalInvoicedPieces;
  skuData.totalInvoicedOtherUnits = totalInvoicedOtherUnits;
  
  skuData.totalReturnedCases = totalReturnedCases;
  skuData.totalReturnedPieces = totalReturnedPieces;
  skuData.totalReturnedOtherUnits = totalReturnedOtherUnits;

  skuData.totalReturnableCases = totalReturnableQty.cs;
  skuData.totalReturnablePieces = totalReturnableQty.pi;
  skuData.totalReturnableOtherUnits = totalReturnableQty.oth;

}


//These are not to be called initially, since the return values will be zero. The totalReturnableOtherUnits etc are quantities
//from previously raised returns
const calculateReturnValues = (skuMap: Record<string, SkuData>) => {
  Object.values(skuMap).forEach((skuData) => {
    calculateReturnValue(skuData);
  });
}

const calculateReturnValue = (skuData: SkuData) => {
  let returnValue = 0;
  skuData.batches.forEach((batch) => {

    batch?.qtyReasonMap &&
    Object.entries(batch.qtyReasonMap).forEach(([key, qtyReasonArray]) => {
      qtyReasonArray.forEach((qtyReason) => {
        const qty = getNormalizedQuantity(
          qtyReason.caseQty,
          qtyReason.pieceQty,
          qtyReason.otherQty,
          skuData.caseToPieceQuantity ?? 0,
          skuData.otherToPieceQuantity ?? 0
        );
        const value = qty * (batch.priceToRetailer ?? 0);
        if (key === "ACCEPTED") {
          batch.acceptedReturnValue = (batch.acceptedReturnValue ?? 0) + value;
        }
        else if (key === "REJECTED") {
          batch.rejectedReturnValue = (batch.rejectedReturnValue ?? 0) + value;
        }
      });
    });

    batch.returnValue = (batch.acceptedReturnValue ?? 0) + (batch.rejectedReturnValue ?? 0);
    returnValue += batch.returnValue ?? 0;

  });
  skuData.totalReturnedValue = returnValue;
}


const calculateNewReturnQuantities = (skuMap: Record<string, SkuData>) => {
  Object.values(skuMap).forEach((skuData) => {
    calculateNetReturnQuantityForEachSku(skuData);
  });
}

const calculateNetReturnQuantityForEachSku = (skuData: SkuData) => {
  let newReturnedCases = 0;
  let newReturnedPieces = 0;
  let newReturnedOtherUnits = 0;

  skuData.batches.forEach((batch) => {
    batch?.qtyReasonMap &&
    Object.entries(batch.qtyReasonMap).forEach(([key, qtyReasonArray]) => {
      let totalCaseQty = 0;
      let totalPieceQty = 0;
      let totalOtherQty = 0;
      
      qtyReasonArray.forEach((qtyReason) => {
        totalCaseQty += qtyReason.caseQty;
        totalPieceQty += qtyReason.pieceQty;
        totalOtherQty += qtyReason.otherQty;
      });
      if (key === "ACCEPTED") {
        batch.newAcceptedReturnedCaseQuantity = totalCaseQty;
        batch.newAcceptedReturnedPieceQuantity = totalPieceQty;
        batch.newAcceptedReturnedOtherQuantity = totalOtherQty;
      } else if (key === "REJECTED") {
        batch.newRejectedReturnedCaseQuantity = totalCaseQty;
        batch.newRejectedReturnedPieceQuantity = totalPieceQty;
        batch.newRejectedReturnedOtherQuantity = totalOtherQty;
      }
    });

    newReturnedCases += (batch.newAcceptedReturnedCaseQuantity ?? 0) + (batch.newRejectedReturnedCaseQuantity ?? 0);
    newReturnedPieces += (batch.newAcceptedReturnedPieceQuantity ?? 0) + (batch.newRejectedReturnedPieceQuantity ?? 0);
    newReturnedOtherUnits += (batch.newAcceptedReturnedOtherQuantity ?? 0) + (batch.newRejectedReturnedOtherQuantity ?? 0);

  });
  
  skuData.newReturnedCases = newReturnedCases;
  skuData.newReturnedPieces = newReturnedPieces;
  skuData.newReturnedOtherUnits = newReturnedOtherUnits;
}


export const getPayload = (rows: SkuData[], mainInvoice: any) => {

  const loginId = JSON.parse(localStorage.authContext).user.loginId;

  const generateSalesDetails = () => {
    const salesDetails: any[] = [];
    rows.forEach((skuData: SkuData) => {
      (skuData.batches || []).forEach((batch) => {
        if (!batch) return;
        const batchIds: any[] = [];

        const map = batch.qtyReasonMap;
        if (!map) return;

        Object.entries(map).forEach(([key, qtyReasonArray]) => {
          (qtyReasonArray || []).forEach((qtyReason: QuantityReason) => {

            if (!(qtyReason.caseQty > 0 || qtyReason.pieceQty > 0 || qtyReason.otherQty > 0)) return

            const batchIdEntry = {
              batchId: batch.batchId,
              caseQty: qtyReason.caseQty ?? 0,
              pieceQty: qtyReason.pieceQty ?? 0,
              otherQty: qtyReason.otherQty ?? 0,
              accepted: key === "ACCEPTED",
              reason: qtyReason.reason ?? ""
            };
            batchIds.push(batchIdEntry);
          });
        });

        if (batchIds.length > 0) {
          const caseQuantity = batchIds.reduce((sum, b) => sum + (b.caseQty ?? 0), 0);
          const pieceQuantity = batchIds.reduce((sum, b) => sum + (b.pieceQty ?? 0), 0);
          const otherUnitQuantity = batchIds.reduce((sum, b) => sum + (b.otherQty ?? 0), 0);

          const salesDetailEntry = {
            supplier: mainInvoice.supplier, // supplier id can be added here if available
            batchCode: batch.batchCode,
            skuCode: batch.skuCode,
            batchId: batch.batchId,

            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,

            batchIds, // use the actual array (so TS infers correct type)
            type: "normal"
          };

          salesDetails.push(salesDetailEntry);
        }
      });
    });

    return salesDetails;
  };

  const salesDetails = generateSalesDetails();

  const payload = {
    referenceNumber: mainInvoice.invoiceNumber || "",
    source: "DMS",
    outletCode: loginId, //supplier id
    type: "primaryreturn",
    loginId: mainInvoice.loginId,
    salesDetails: salesDetails
  }

  return payload
}


export interface ViewReturnBatchDetails {

  batchId: string;
  skuCode: string;
  batchCode: string;
  
  totalReturnedCaseQuantity?: number;
  totalReturnedPieceQuantity?: number;
  totalReturnedOtherQuantity?: number;

  totalInvoicedCaseQuantity?: number;
  totalInvoicedPieceQuantity?: number;
  totalInvoicedOtherQuantity?: number;
  
  priceToRetailer: number;

  mrp: number;

  qtyReasonMap?: Record<string, QuantityReason[]>;
  returnValue: number;
  otherUnitName?: string;

}

export interface ViewReturnBatchDetailsWithoutGRN {

  batchId: string;
  skuCode: string;
  batchCode: string;
  
  totalReturnedCaseQuantity?: number;
  totalReturnedPieceQuantity?: number;
  totalReturnedOtherQuantity?: number;

  totalInvoicedCaseQuantity?: number;
  totalInvoicedPieceQuantity?: number;
  totalInvoicedOtherQuantity?: number;
  
  priceToRetailer: number;

  mrp: number;

  qtyReason?: QuantityReason[];
  returnValue: number;
  otherUnitName?: string;

}



export interface ViewReturnSkuData {
  id: string; 
  skuCode: string;
  batchCode: string;
  skuName: string;
  packType: string;
  brand?: string;

  priceToRetailer?: number;
  mrp?: number;

  totalReturnedCases?: number;
  totalReturnedPieces?: number;
  totalReturnedOtherUnits?: number;

  totalInvoicedCases?: number;
  totalInvoicedPieces?: number;
  totalInvoicedOtherUnits?: number;

  totalReturnedValue?: number;

  caseToPieceQuantity?: number;
  otherToPieceQuantity?: number;

  showMultipleRows?: boolean
  otherUnitName?: string

  batches: ViewReturnBatchDetails[];
  mergedRows: ViewReturnBatchDetails[];
}



export const generateViewReturnWithoutGRNRows = async (returnData: any): Promise<ViewReturnSkuData[]> => {

  const {otherUnitLabelPrimaryReturn} = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  const skuMap: Record<string, ViewReturnSkuData> = {};

  if (returnData && Array.isArray(returnData.salesDetails)) {
    returnData.salesDetails.forEach((batchNode: any) => {
      const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";
      
      const batchDetails: ViewReturnBatchDetailsWithoutGRN = {
        batchId: batchNode.batchId ?? "unassigned",
        skuCode: skuCode,
        batchCode: skuCode,
        totalReturnedCaseQuantity: Math.abs(batchNode.initialCaseQuantity ?? 0),
        totalReturnedPieceQuantity: Math.abs(batchNode.initialPieceQuantity ?? 0),
        totalReturnedOtherQuantity: Math.abs(batchNode.initialOtherUnitQuantity ?? 0),
        priceToRetailer: batchNode.price ?? 0,
        mrp: batchNode.mrp ?? 0,
        returnValue:Math.abs(batchNode.netAmount ?? 0),
        qtyReason: [],
        otherUnitName: products[skuCode]?.otherUnitName ?? otherUnitLabelPrimaryReturn
      };


      batchNode.batchIds.map((returnedBatch: any) => {
        if (returnedBatch.batchId === batchDetails.batchId) {
          const qtyObj = {
            reason: returnedBatch.reason,
            caseQty: returnedBatch.caseQty ?? 0,
            pieceQty: returnedBatch.pieceQty ?? 0,
            otherQty: returnedBatch.otherQty ?? 0,
          }
          batchDetails.qtyReason?.push(qtyObj)
        }
      });

      if (!skuMap[skuCode]) {
        skuMap[skuCode] = { id: skuCode, skuCode, batchCode: skuCode, skuName: "", batches: [], packType: "", mergedRows: []};
      }
      skuMap[skuCode].batches.push(batchDetails);
      skuMap[skuCode].packType = getPieceFilterMapping(products[skuCode]?.pieceSize);
      skuMap[skuCode].brand = products[skuCode]?.brand ?? "";
      skuMap[skuCode].skuName = products[skuCode]?.skuDescription ?? "";
      skuMap[skuCode].caseToPieceQuantity = batchNode?.productInfo?.caseToPieceQuantity ?? 0;
      skuMap[skuCode].otherToPieceQuantity = batchNode?.productInfo?.otherUnitToPieceQuantity ?? 0;
      skuMap[skuCode].priceToRetailer = batchNode.price ?? 0;
      skuMap[skuCode].mrp = batchNode.mrp ?? 0;
      skuMap[skuCode].showMultipleRows = true
      skuMap[skuCode].otherUnitName = products[skuCode]?.otherUnitName ?? otherUnitLabelPrimaryReturn 

    });
  }

  calculateSkuTotalsForViewReturn(skuMap, products);

  Object.values(skuMap).forEach((skuData) => {
    skuData.mergedRows = skuData.batches;
  });

  console.log("Generated View SKU Map:", skuMap);
  return Object.values(skuMap);
}
export const generateViewReturnRows = async (returnData: any, invoiceData?: any): Promise<ViewReturnSkuData[]> => {

  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  const skuMap: Record<string, ViewReturnSkuData> = {};

  if (returnData && Array.isArray(returnData.salesDetails)) {
    returnData.salesDetails.forEach((batchNode: any) => {
      const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";
      
      const batchDetails: ViewReturnBatchDetails = {
        batchId: batchNode.batchId ?? "unassigned",
        skuCode: skuCode,
        batchCode: skuCode,
        totalReturnedCaseQuantity: Math.abs(batchNode.initialCaseQuantity ?? 0),
        totalReturnedPieceQuantity: Math.abs(batchNode.initialPieceQuantity ?? 0),
        totalReturnedOtherQuantity: Math.abs(batchNode.initialOtherUnitQuantity ?? 0),
        priceToRetailer: batchNode.price ?? 0,
        mrp: batchNode.mrp ?? 0,
        returnValue:Math.abs(batchNode.netAmount ?? 0)
      };

      batchNode.batchIds.map((returnedBatch: any) => {
        if (returnedBatch.batchId === batchDetails.batchId) {
          const key = returnedBatch.accepted ? "ACCEPTED" : "REJECTED";
          if (!batchDetails.qtyReasonMap?.[key]) {
            batchDetails.qtyReasonMap = batchDetails.qtyReasonMap || {};
            batchDetails.qtyReasonMap[key] = [];
          }
          batchDetails.qtyReasonMap[key]?.push({
            caseQty: returnedBatch.caseQty ?? 0,
            pieceQty: returnedBatch.pieceQty ?? 0,
            otherQty: returnedBatch.otherQty ?? 0,
            reason: returnedBatch.reason ?? ""
          });
        }
      });
      
      if (!skuMap[skuCode]) {
        skuMap[skuCode] = { id: skuCode, skuCode, batchCode: skuCode, skuName: "", batches: [], packType: "", mergedRows: []};
      }
      skuMap[skuCode].batches.push(batchDetails);
      skuMap[skuCode].packType = getPieceFilterMapping(products[skuCode]?.pieceSize);
      skuMap[skuCode].brand = products[skuCode]?.brand ?? "";
      skuMap[skuCode].skuName = products[skuCode]?.skuDescription ?? "";
      skuMap[skuCode].caseToPieceQuantity = batchNode?.productInfo?.caseToPieceQuantity ?? 0;
      skuMap[skuCode].otherToPieceQuantity = batchNode?.productInfo?.otherUnitToPieceQuantity ?? 0;
      skuMap[skuCode].priceToRetailer = batchNode.price ?? 0;
      skuMap[skuCode].mrp = batchNode.mrp ?? 0;
      skuMap[skuCode].showMultipleRows = true

    });
  }

  if (invoiceData && Array.isArray(invoiceData.salesDetails)) {
    invoiceData.salesDetails.forEach((batchNode: any) => {
      const skuCode: string = batchNode.skuCode ?? batchNode.batchCode ?? "";
      const skuData = skuMap[skuCode];
      if (skuData) {
        const batch = skuData.batches.find((b) => b.batchId === batchNode.batchId);
        if (batch) {
          batch.totalInvoicedCaseQuantity = batchNode.initialCaseQuantity ?? 0;
          batch.totalInvoicedPieceQuantity = batchNode.initialpieceQuantity ?? 0;
          batch.totalInvoicedOtherQuantity = batchNode.initialOtherUnitQuantity ?? 0;
        }
      }
    });
  }

  calculateSkuTotalsForViewReturn(skuMap, products);

  Object.values(skuMap).forEach((skuData) => {
    skuData.mergedRows = skuData.batches;
  });

  console.log("Generated View SKU Map:", skuMap);
  return Object.values(skuMap);
}

const calculateSkuTotalsForViewReturn = (
  skuMap: Record<string, ViewReturnSkuData>,
  products: any
) => {
  // iterate values of the object
  Object.values(skuMap).forEach((skuData) => {
    calculateTotalsForViewReturn(skuData, products[skuData.skuCode]);
  });
};

const calculateTotalsForViewReturn = (skuData: ViewReturnSkuData, products: any) => {

  let totalReturnedCases = 0;
  let totalReturnedPieces = 0;
  let totalReturnedOtherUnits = 0;
  
  let totalInvoicedCases = 0;
  let totalInvoicedPieces = 0;
  let totalInvoicedOtherUnits = 0;

  let totalReturnedValue = 0;
  
  skuData.batches.forEach((batch) => {
    totalReturnedCases += (batch.totalReturnedCaseQuantity ?? 0);
    totalReturnedPieces += (batch.totalReturnedPieceQuantity ?? 0);
    totalReturnedOtherUnits += (batch.totalReturnedOtherQuantity ?? 0);
    totalInvoicedCases += (batch.totalInvoicedCaseQuantity ?? 0);
    totalInvoicedPieces += (batch.totalInvoicedPieceQuantity ?? 0);
    totalInvoicedOtherUnits += (batch.totalInvoicedOtherQuantity ?? 0);
    totalReturnedValue += (batch.returnValue ?? 0);
  });

  skuData.totalInvoicedCases = totalInvoicedCases;
  skuData.totalInvoicedPieces = totalInvoicedPieces;
  skuData.totalInvoicedOtherUnits = totalInvoicedOtherUnits;

  const normalizedInvoicedQty = getNormalizedQuantity(
    totalInvoicedCases,
    totalInvoicedPieces,
    totalInvoicedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );

  const invoicedQtyBreakdown = addToUomWiseAllocationPrimaryReturn(
    products,
    normalizedInvoicedQty,
    ""
  );

  skuData.totalInvoicedCases = invoicedQtyBreakdown.cs;
  skuData.totalInvoicedPieces = invoicedQtyBreakdown.pi;
  skuData.totalInvoicedOtherUnits = invoicedQtyBreakdown.oth;

  skuData.totalReturnedCases = totalReturnedCases;
  skuData.totalReturnedPieces = totalReturnedPieces;
  skuData.totalReturnedOtherUnits = totalReturnedOtherUnits;

  const normalizedReturnedQty = getNormalizedQuantity(
    totalReturnedCases,
    totalReturnedPieces,
    totalReturnedOtherUnits,
    skuData.caseToPieceQuantity ?? 0,
    skuData.otherToPieceQuantity ?? 0
  );

  const returnedQtyBreakdown = addToUomWiseAllocationPrimaryReturn(
    products,
    normalizedReturnedQty,
    ""
  );
  
  skuData.totalReturnedCases = returnedQtyBreakdown.cs;
  skuData.totalReturnedPieces = returnedQtyBreakdown.pi;
  skuData.totalReturnedOtherUnits = returnedQtyBreakdown.oth;
  skuData.totalReturnedValue = totalReturnedValue;

}


export const generateSummaryValuesForEdit = (rows: SkuData[]) => {
 
  let totalReturnedCases = 0;
  let totalReturnedPieces = 0;
  let totalReturnedOtherUnits = 0;
  
  let totalReturnedValue = 0;

  rows.forEach((skuData) => {
    totalReturnedCases += skuData.newReturnedCases ?? 0;
    totalReturnedPieces += skuData.newReturnedPieces ?? 0;
    totalReturnedOtherUnits += skuData.newReturnedOtherUnits ?? 0;
    totalReturnedValue += skuData.totalReturnedValue ?? 0;
  });
  
  return {
    totalReturnedCases,
    totalReturnedPieces,
    totalReturnedOtherUnits,
    totalReturnedValue
  };
}

export const generateSummaryValuesWithoutGRN = (rows: SkuDataWithoutGRN[]) => {
 
  let totalReturnedCases = 0;
  let totalReturnedPieces = 0;
  let totalReturnedOtherUnits = 0;
  
  let totalReturnedValue = 0;

  rows.forEach((skuData) => {
    totalReturnedCases += skuData.totalReturnedCases ?? 0;
    totalReturnedPieces += skuData.totalReturnedPieces ?? 0;
    totalReturnedOtherUnits += skuData.totalReturnedOtherUnits ?? 0;
    totalReturnedValue += skuData.totalReturnedValue ?? 0;
  });
  
  return {
    totalReturnedCases,
    totalReturnedPieces,
    totalReturnedOtherUnits,
    totalReturnedValue
  };
}



export const generateSkuDataForUnsellableReturn = async () : Promise<Record<string, SkuDataForUnsellableReturn>> => {
  let skuData: Record<string, SkuDataForUnsellableReturn> = {};
 
  const {otherUnitLabelPrimaryReturn} = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");


  let stockData = await getStockData();
  stockData = stockData.filter(obj => !obj.grnNumber);
  const productsDbResult = await getDataFromLocalDb("Product");
  const products: any = productsDbResult?.data?.[0]?.data ?? {};

  stockData?.forEach((obj: any) => {
    const {
      skuCode,
      batchId,
      quantityType,
      qty,
      reason,
    } = obj;
    if (!skuData[skuCode]) {
      skuData[skuCode] = {
        skuCode: skuCode,
        skuName: products[skuCode]?.skuDescription || "",
        caseToPieceQty: products[skuCode]?.caseToPieceQuantity || 0,
        otherToPieceQty: products[skuCode]?.otherUnitToPieceQuantity || 0,
        batchCode: skuCode || "",
        batchIds: [batchId],
        batchDetails: [],
        otherUnitName: products[skuCode]?.otherUnitName ?? otherUnitLabelPrimaryReturn
      };
    }
    if (!skuData[skuCode].batchIds.includes(batchId)) {
      skuData[skuCode].batchIds.push(batchId);
    }
  });


  Object.values(skuData).forEach((sku) => {
    sku.batchIds.forEach((batchId) => {
      const stockObj = stockData.filter(
        (obj: any) => obj.skuCode === sku.skuCode && obj.batchId === batchId
      );
      
      let totalUnsellableCaseQty = 0
      let totalUnsellablePieceQty = 0
      let totalUnsellableOtherQty = 0

      let reasonQuantityMap: Record<string, QuantityObj> = {};

      stockObj.forEach((o: any) => {
        const reasonKey = o.reason ?? "";

        // Initialize if not present
        if (!reasonQuantityMap[reasonKey]) {
          reasonQuantityMap[reasonKey] = {
            caseQty: 0,
            pieceQty: 0,
            otherQty: 0,
          };
        }

        if (o.quantityType === "caseQty"){

          totalUnsellableCaseQty += parseInt(o.qty)
          reasonQuantityMap[reasonKey].caseQty = parseInt(o.qty)
          reasonQuantityMap[reasonKey].unsellableCaseQty = parseInt(o.qty)

        } else if (o.quantityType === "pieceQty"){

          totalUnsellablePieceQty += parseInt(o.qty)
          reasonQuantityMap[reasonKey].pieceQty = parseInt(o.qty)
          reasonQuantityMap[reasonKey].unsellablePieceQty = parseInt(o.qty)

        } else if (o.quantityType === "otherQty"){

          totalUnsellableOtherQty += parseInt(o.qty)
          reasonQuantityMap[reasonKey].otherQty = parseInt(o.qty)
          reasonQuantityMap[reasonKey].unsellableOtherQty = parseInt(o.qty)
        }
      });

      const batchDetail: withoutGRNBatchDetails = {
        batchId: batchId,
        skuCode: sku.batchCode,
        skuName: sku.skuName,
        initialUnsellableCaseQty: totalUnsellableCaseQty,
        initialUnsellablePieceQty: totalUnsellablePieceQty,
        initialUnsellableOtherQty: totalUnsellableOtherQty,
        unsellableCaseQty: totalUnsellableCaseQty,
        unsellablePieceQty: totalUnsellablePieceQty,
        unsellableOtherQty: totalUnsellableOtherQty,
        initialReasonQuantityMap: reasonQuantityMap,
        reasonQuantityMap: reasonQuantityMap,
        caseToPieceQty: sku.caseToPieceQty,
        otherToPieceQty: sku.otherToPieceQty,
        otherUnitName: sku.otherUnitName ?? "",
        priceTodistributor: 0,
        mrp: 0
      };

      sku?.batchDetails?.push(batchDetail);

    });
  });

  let pricingData = await fetchBatchWisePricingOfLoginId(JSON.parse(localStorage.authContext)?.user?.loginId ?? "", Object.keys(skuData));
  const batchIdPriceMap: Record<string, Record<string, any>> = {};

  pricingData.forEach((pricing: any) => {
    const skuCode = pricing.skuCode;
    const batchId = pricing.batchId;
    const priceTodistributor = pricing.packPtr;
    const mrp = pricing.mrp;
    
    if (!batchIdPriceMap[skuCode]) {
      batchIdPriceMap[skuCode] = {};
    }
    batchIdPriceMap[skuCode][batchId] = {
      priceTodistributor,
      mrp
    };
  });

  Object.keys(skuData).forEach((skuCode) => {
    const sku = skuData[skuCode];

    const validBatches = sku.batchDetails?.filter((batch) => {
      const price = batchIdPriceMap[skuCode]?.[batch.batchId]?.priceTodistributor;
      return price !== undefined && price !== null;
    });

    if (validBatches?.length === 0) {
      delete skuData[skuCode];
      return;
    }

    sku.batchDetails = validBatches?.map((batch) => {
      batch.priceTodistributor =
        batchIdPriceMap[skuCode][batch.batchId]?.priceTodistributor || 0;
      batch.mrp =
        batchIdPriceMap[skuCode][batch.batchId]?.mrp || 0;
      return batch;
    });
  });

  return skuData;
}

export interface SkuDataWithoutGRN {
  id: string;  
  skuCode: string;
  batchCode: string;
  skuName: string;

  priceTodistributor?: number;

  totalReturnedCases?: number;
  totalReturnedPieces?: number;
  totalReturnedOtherUnits?: number;
  totalReturnedValue?: number;

  caseToPieceQuantity?: number;
  otherToPieceQuantity?: number;

  showMultipleRows?: boolean;
  otherUnitName?: string;

  batches: BatchDetailsWithOutGRN[];
  mergedRows: BatchDetailsWithOutGRN[];
}


export interface BatchDetailsWithOutGRN {
  batchId: string;
  skuCode: string;
  batchCode: string;
  totalReturnedCaseQuantity?: number;
  totalReturnedPieceQuantity?: number;
  totalReturnedOtherQuantity?: number;
  returnValue?: number;
  priceTodistributor: number;
  mrp: number;
  qtyReason: QuantityObj[];
  otherUnitName: string;
}



export const generateReturnRowsForWithoutGRN = async (rowData: Record<string, withoutGRNBatchDetails[]>): Promise<SkuDataWithoutGRN[]> => {
  let skuData : SkuDataWithoutGRN[] = []

  Object.values(rowData).forEach((batches: withoutGRNBatchDetails[]) => {
    if (batches.length === 0) return;
    
    const firstBatch = batches[0];
    const skuCode = firstBatch.skuCode;
    
    const skuEntry: SkuDataWithoutGRN = {
      id: skuCode,
      skuCode: skuCode,
      batchCode: skuCode,
      skuName: firstBatch.skuName,
      caseToPieceQuantity: firstBatch.caseToPieceQty,
      otherToPieceQuantity: firstBatch.otherToPieceQty,
      showMultipleRows: true,
      priceTodistributor: firstBatch.priceTodistributor,
      batches: [],
      mergedRows: [],
    };

    batches.forEach((batch) => {
      const batchEntry: BatchDetailsWithOutGRN = {
        batchId: batch.batchId,
        skuCode: batch.skuCode,
        batchCode: batch.skuCode,
        totalReturnedCaseQuantity: 0,
        totalReturnedPieceQuantity: 0,
        totalReturnedOtherQuantity: 0,
        priceTodistributor: batch.priceTodistributor || 0,
        qtyReason: [],
        otherUnitName: batch.otherUnitName,
        mrp: batch.mrp || 0
      };

      // Calculate return value for the batch
      const qtyReason: QuantityObj[] = [];
      let totalCaseQty = 0;
      let totalPieceQty = 0;
      let totalOtherQty = 0;
      let returnValue = 0;

      Object.entries(batch.reasonQuantityMap || {}).forEach(([reason, qtyObj]) => {
        qtyReason.push({
          caseQty: qtyObj.caseQty,
          pieceQty: qtyObj.pieceQty,
          otherQty: qtyObj.otherQty,
          reason: reason
        });

        totalCaseQty += qtyObj.caseQty;
        totalPieceQty += qtyObj.pieceQty;
        totalOtherQty += qtyObj.otherQty;
        
        const normalizedQty = getNormalizedQuantity(
          qtyObj.caseQty,
          qtyObj.pieceQty,
          qtyObj.otherQty,
          skuEntry.caseToPieceQuantity ?? 0,
          skuEntry.otherToPieceQuantity ?? 0
        );
        
        returnValue += normalizedQty * (batchEntry.priceTodistributor ?? 0);
      });

      batchEntry.totalReturnedCaseQuantity = totalCaseQty;
      batchEntry.totalReturnedPieceQuantity = totalPieceQty;
      batchEntry.totalReturnedOtherQuantity = totalOtherQty;
      batchEntry.returnValue = returnValue;
      batchEntry.qtyReason = qtyReason;
      skuEntry.batches.push(batchEntry);
    });

    // Calculate total returned values for the SKU
    let totalReturnedCases = 0;
    let totalReturnedPieces = 0;
    let totalReturnedOtherUnits = 0;
    let totalReturnedValue = 0;

    skuEntry.batches.forEach((batch) => {
      totalReturnedCases += (batch.totalReturnedCaseQuantity ?? 0);
      totalReturnedPieces += (batch.totalReturnedPieceQuantity ?? 0);
      totalReturnedOtherUnits += (batch.totalReturnedOtherQuantity ?? 0);
      totalReturnedValue += (batch.returnValue ?? 0);
    });

    skuEntry.totalReturnedCases = totalReturnedCases;
    skuEntry.totalReturnedPieces = totalReturnedPieces;
    skuEntry.totalReturnedOtherUnits = totalReturnedOtherUnits;
    skuEntry.totalReturnedValue = totalReturnedValue;
    skuEntry.mergedRows = skuEntry.batches;
    skuEntry.otherUnitName = skuEntry.batches[0].otherUnitName

    skuData.push(skuEntry);
  });

  return skuData


}

export const getPayloadForReturnWithoutGRN = (rows: SkuDataWithoutGRN[], summaryData: SummaryData) => {

  const loginId = JSON.parse(localStorage.authContext).user.loginId;

  const generateSalesDetails = () => {
    const salesDetails: any[] = [];
    rows.forEach((skuData: SkuDataWithoutGRN) => {
      (skuData.batches || []).forEach((batch) => {
        if (!batch) return;
        const batchIds: any[] = [];

        batch.qtyReason.forEach((qtyReason: QuantityObj) => {
        
          if (!(qtyReason.caseQty > 0 || qtyReason.pieceQty > 0 || qtyReason.otherQty > 0)) return
          const batchIdEntry = {
            batchId: batch.batchId,
            caseQty: qtyReason.caseQty ?? 0,
            pieceQty: qtyReason.pieceQty ?? 0,
            otherQty: qtyReason.otherQty ?? 0,
            reason: qtyReason.reason ?? ""
          };
          batchIds.push(batchIdEntry);
        });

         if (batchIds.length > 0) {
          const caseQuantity = batchIds.reduce((sum, b) => sum + (b.caseQty ?? 0), 0);
          const pieceQuantity = batchIds.reduce((sum, b) => sum + (b.pieceQty ?? 0), 0);
          const otherUnitQuantity = batchIds.reduce((sum, b) => sum + (b.otherQty ?? 0), 0);

          const salesDetailEntry = {
            supplier: summaryData.companySupplier,
            batchCode: batch.batchCode,
            skuCode: batch.skuCode,
            batchId: batch.batchId,

            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,

            batchIds,
            type: "normal"
          };

          salesDetails.push(salesDetailEntry);
        }
      });
    });

    return salesDetails;
  };

  const salesDetails = generateSalesDetails();

  const payload = {
    source: "DMS",
    outletCode: loginId, //supplier id
    type: "primaryreturn",
    loginId: loginId,
    salesDetails: salesDetails
  }

  return payload
}






